@if (field) {
  <mat-form-field class="text-input-wrapper">
    <mat-label>
      {{ label | translate }}
    </mat-label>

    <!--suppress HtmlFormInputWithoutLabel -->
    <input
      matInput
      type="text"
      [formControl]="control"
      [placeholder]="placeholder | translate"
      autocomplete="off"
    />

    <mat-hint>
      {{ placeholder | translate }}
    </mat-hint>
  </mat-form-field>
}
